export const ServiceTypeUriPaths = {
  BASE: '/service-type',
  SLASH: '/',
  UNIQUE_IDENTIFIER: '/service-types/unique-identifier',
  UNIQUE_NAME: '/service-types/unique-name'
};
